import React from 'react';
export function getColorHtml(hex){
  return <div className='color' style={{ boxSizing: 'border-box', backgroundColor: hex, width: 15, height: 15, border: '1px solid #ccc' }}>&nbsp;</div>
}
